import { SelectChangeEvent } from "@mui/material"
import { useMemo, useState } from "react"
import intl from "src/internationalization/intl"
import { IFetchOpportunitiesFilters } from "src/services/api/opportunities"

export type OpportunityStatusFilter = "active" | "all" | "expired"

export const useOpportunitiesFilters = () => {
    const [sortDirection, setSortDirection] = useState<string>("")
    const [clientsImpactedFilter, setClientsImpactedFilter] = useState<string>("")
    const [statusFilter, setStatusFilter] = useState<OpportunityStatusFilter>("active")

    const sortOptions = [
        { value: "", label: "Ordenar por" },
        { value: "DESC", label: "Mais recente" },
        { value: "ASC", label: "Mais antigos" },
    ]

    const statusOptions = [
        { value: "active", label: intl("statusActive") },
        { value: "all", label: intl("statusAll") },
        { value: "expired", label: intl("statusExpired") },
    ]

    const clientsImpactedOptions = [
        { value: "", label: "Filtro de clientes impactados" },
        { value: "1-10", label: "1 a 10 clientes" },
        { value: "10-30", label: "10 a 30 clientes" },
        { value: "30-50", label: "30 a 50 clientes" },
        { value: "50-70", label: "50 a 70 clientes" },
        { value: "70-100", label: "70 a 100 clientes" },
        { value: "100+", label: "Mais de 100 clientes" },
    ]

    const filters = useMemo<IFetchOpportunitiesFilters>(() => {
        const filterObj: IFetchOpportunitiesFilters = {}

        if (sortDirection) {
            filterObj.sort_direction = sortDirection as "ASC" | "DESC"
        }

        if (clientsImpactedFilter) {
            if (clientsImpactedFilter === "1-10") {
                filterObj.min_clients_impacted = 1
                filterObj.max_clients_impacted = 10
            } else if (clientsImpactedFilter === "10-30") {
                filterObj.min_clients_impacted = 10
                filterObj.max_clients_impacted = 30
            } else if (clientsImpactedFilter === "30-50") {
                filterObj.min_clients_impacted = 30
                filterObj.max_clients_impacted = 50
            } else if (clientsImpactedFilter === "50-70") {
                filterObj.min_clients_impacted = 50
                filterObj.max_clients_impacted = 70
            } else if (clientsImpactedFilter === "70-100") {
                filterObj.min_clients_impacted = 70
                filterObj.max_clients_impacted = 100
            } else if (clientsImpactedFilter === "100+") {
                filterObj.min_clients_impacted = 100
            }
        }

        return filterObj
    }, [sortDirection, clientsImpactedFilter])

    const handleSortChange = (event: SelectChangeEvent<unknown>) => {
        setSortDirection(event.target.value as string)
    }

    const handleClientsImpactedChange = (event: SelectChangeEvent<unknown>) => {
        setClientsImpactedFilter(event.target.value as string)
    }

    const handleStatusChange = (event: SelectChangeEvent<unknown>) => {
        setStatusFilter(event.target.value as OpportunityStatusFilter)
    }

    return {
        sortDirection,
        clientsImpactedFilter,
        statusFilter,
        sortOptions,
        statusOptions,
        clientsImpactedOptions,
        filters,
        handleSortChange,
        handleClientsImpactedChange,
        handleStatusChange,
    }
}
